import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useRef, useState } from "react";
export function canReadGrantedGeolocation(permission) {
  return permission === "granted";
}

// Search observes permission state on mount without prompting. It may read a
// position only from a search-input gesture, and only after an existing grant.
export function useGrantedGeolocation() {
  const $ = _c(8);
  const [permission, setPermission] = useState("checking");
  const [location, setLocation] = useState(null);
  const requestedPosition = useRef(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      if (typeof navigator === "undefined" || !navigator.geolocation || !navigator.permissions?.query) {
        setPermission("unsupported");
        return;
      }
      let active = true;
      let permissionStatus = null;
      const updatePermission = () => {
        if (active) {
          setPermission(permissionStatus?.state || "unknown");
        }
      };
      navigator.permissions.query({
        name: "geolocation"
      }).then(status => {
        if (!active) {
          return;
        }
        permissionStatus = status;
        updatePermission();
        permissionStatus.addEventListener?.("change", updatePermission);
      }).catch(() => {
        if (active) {
          setPermission("unknown");
        }
      });
      return () => {
        active = false;
        permissionStatus?.removeEventListener?.("change", updatePermission);
      };
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] !== permission) {
    t2 = () => {
      if (!canReadGrantedGeolocation(permission) || requestedPosition.current) {
        return;
      }
      requestedPosition.current = true;
      navigator.geolocation.getCurrentPosition(t3 => {
        const {
          coords
        } = t3;
        setLocation({
          latitude: coords.latitude,
          longitude: coords.longitude
        });
      }, () => {
        requestedPosition.current = false;
        setLocation(null);
      }, {
        maximumAge: 60000,
        timeout: 10000
      });
    };
    $[2] = permission;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const requestGrantedLocation = t2;
  let t3;
  if ($[4] !== location || $[5] !== permission || $[6] !== requestGrantedLocation) {
    t3 = {
      location,
      permission,
      requestGrantedLocation
    };
    $[4] = location;
    $[5] = permission;
    $[6] = requestGrantedLocation;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}